import cn from "app/utils/classnames";

interface MoreGamesButtonProps {
  className?: string;
}

// Wrapper for the more-games-button webcomponent since the tailwind
// classname got crazy
export default function MoreGamesButton(props: MoreGamesButtonProps) {
  return (
    <more-games-button
      className={cn(
        // "[all:unset]",
        "leading-none",
        "[&::part(button)]:bg-white",
        "[&::part(button)]:text-black",
        "[&::part(button)]:font-mono",
        "[&::part(button)]:uppercase",
        "[&::part(button)]:font-normal",
        "[&::part(button)]:text-[16px]",
        "[&::part(button)]:w-32",
        "[&::part(button)]:max-w-56",
        "[&::part(button)]:h-9.5",
        "[&::part(button)]:px-2",
        "[&::part(button)]:py-1",
        "transition-all",
        "border border-black rounded-md",
        "flex justify-center",
        "shadow-[4px_4px_0_0px_black] active:shadow-[0px_0px_0px_0px_black] -translate-[4px] active:translate-[0px]",
        "font-mono uppercase text-black",
        props.className
      )}
    ></more-games-button>
  );
}
